import { useQuery } from '@tanstack/react-query'
import { queryKeys } from 'commons/hooks/services/queryKeys'
import { featureFlippingService } from 'commons/services/featureFlippingService'
import type { FeatureFlippingResponse } from 'commons/types/featureFlippingTypes'

export const useFeatureFlipping = () => {
	return useQuery<FeatureFlippingResponse>({
		queryKey: queryKeys.featureFlipping.getFeatureFlipping(),
		queryFn: featureFlippingService.getFeatureFlipping
	})
}
